import { FormService } from './FormService';

export class PrepressNcrService extends FormService {
    constructor() {
        super("PrepressNcrs");
    }
}